<script>
import resources from './resources'

export default {
  name: 'gadget-summary-billing',
  mixins: [resources]
}
</script>

<template lang="pug">
  section.gadget-resumo-faturamento.white-bg.wrapper.half-width.gadget
    .gadget-title
      | Resumo de Faturamento
    .actions
      span.icon 
      ul
        li.exclude Remover
        li.half-width Lado a Lado
        li.full-width Tela Inteira
    div
      .col-xs-12.col-sm-6
        label.light-red Mês de Referência
        h3.medium-gray Junho de 2017
      .col-xs-12.col-sm-6
        label.light-red Total Faturado
        h3.medium-gray R$ {{ total }}
    div(style='margin-top:15px')
      .col-xs-12
        label.light-red Movimentação por Convênio
      .table.col-xs-12
        .row.hidden-xs.hidden-sm
          .col-xs-12.col-sm-4.col-title.active Convênio
          .col-xs-12.col-sm-4.col-title.text-center Eventos
          .col-xs-12.col-sm-4.col-title Faturamento R$
        .order-by.hidden-md.hidden-lg
          | Ordenar por
          span
            select#ordenar-por(name='Ordenar por')
              option(value='Convênio') Convênio
              option(value='Eventos') Eventos
              option(value='Faturamento') Faturamento
        ul.row
          li(v-for="item in statistics")
            .col-xs-12.col-sm-4
              small.grey
                | Convênio
                br
              | {{ item.covenant_name }}
            .col-xs-12.col-sm-4.text-center
              small.grey
                | Eventos
                br
              | {{ item.total }}
            .col-xs-12.col-sm-4.text-right
              small.grey
                | Faturamento
                br
              | R$ {{ item.amount }}
            .clearfix
</template>



// WEBPACK FOOTER //
// src/app/team/dashboard/gadget/components/summary-billing/summary-billing.vue